module.exports = __webpack_public_path__ + "img/18.32155151.jpg";